import { atom } from 'jotai';

import type {
  DataStreamModel,
  LogSourceConfigDTO,
  LogSourceModel,
  LogSourcesDialogMode
} from './LogSourcesCreate.types';

export const logSourcesDialogOpenAtom = atom(false);
export const logSourcesDialogModeAtom =
  atom<LogSourcesDialogMode>('AddLogSources');
export const savingInProgressAtom = atom(false);
export const logSourcesAtom = atom<LogSourceModel[]>([]);
export const inputConfigAtom = atom('');
export const editedLogSourcesAtom = atom<LogSourceConfigDTO | null>(null);
export const hostNameAtom = atom('');
export const orgNameAtom = atom('');
export const searchQueryAtom = atom('');
export const filterSourceAtom = atom<'all' | 'selected'>('all');

// Calculating the selected source count
export const selectedSourceCountAtom = atom((get) => {
  const logSources = get(logSourcesAtom);
  return logSources?.reduce((count, product) => {
    if (product?.isSelected) {
      return count + 1; // Count the selected product
    }
    const selectedStreams = product?.data_streams?.filter(
      (stream: DataStreamModel & { isSelected?: boolean }) => stream?.isSelected
    );
    return count + (selectedStreams?.length ?? 0); // Count the selected streams
  }, 0);
});
